<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>公司调度单使用说明:
					<span>1、通过车辆、车头+车挂(别名)、构建一个组合名称,组合名称可以自定义,相当于一个仓库</span><br>
					<span class="red">2、如果中途,这个组合发生变化则需要进行盘点处理,重新建立</span><br>
					<span>3、查询关键字:仓库名称、车牌、车挂(新版支持)。</span><br>
				</h5>
			</div>
		</div>

		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-btn-Excel @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>
			</div>
		</div>


		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm" :api_url="sel_action"
			:api_action="upd_action" :api_method="edit_flag" :api_check="check_key" />

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[0].val" @click="sel_row(user.item,'all')" @dblclick="edit_data">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='imageList'">
							<ul>
								<li v-for="(t,id) in d.val" :index="id">
									<button @click="fun_show_detail(t)">{{t.f_name}}</button>
								</li>
							</ul>
						</div>
						{{d.val}}
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">
				<div class="pop_content_body">
					<div class="pre_tan_head_close">
						<!-- <a class="close" href="javascript:void(0);" @click="closeshow()"></a> -->
						<img src="../../assets/image/shan1.png" @click="closeshow" />
					</div>
					<div class="pre_leve_one">
						<h3 class="cen">{{title}}</h3>
						<!-- 操作按钮生成 -->
						<div class="content_edit">
							<div class="content_edit_item" v-show="show_btn">
								<pre-button @button-event="select_method" :pre_control="control" />


							</div>
							<div class="content_edit_item" v-show="sheet_flag!=''?true:false">
								<h3 class="red">
									{{sheet_flag}}
								</h3>
							</div>
						</div>
						<!-- 这里放主单据编辑内容-->
						<div class="content_edit">
							<div class="content_edit_item tab-row">
								<label style="width: 108px;">仓库名称:</label>
								<input type="text" class="long2" v-model="store_name" placeholder="仓库名称"
									@keyup.enter="fun_upd('_add')" />
							</div>

							<div class="content_edit_item tab-row">
								<preselect :inData="checkJson(trans_car)" @com-event="refresh_view_edit" />

								<div class="part-1">
									<label style="width: 108px;">车挂:</label>
									<input type="text" class="long1" v-model="sel_carexp_name" placeholder="选择车挂"
										@change="fun_change_carexp()" />
									<el-select v-model="sel_carexp_id" clearable class="long1" placeholder="待选"
										@change="choseValue($event,'carexp')">
										<el-option v-for="item in list_carexp" :key="item.id" :label="item.val"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div class="part-1">
									<label style="width: 108px;">车挂别名:</label>
									<input type="text" class="long1" v-model="sel_carexpbm_name" placeholder="选择别名"
										@change="fun_change_carexpbm()" />
									<el-select v-model="sel_carexpbm_id" clearable class="long1" placeholder="待选"
										@change="choseValue($event,'carexpbm')">
										<el-option v-for="item in list_carexpbm" :key="item.id" :label="item.val"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
							</div>

							<div class="content_edit_item tab-row">
								<pretext :inData="checkJson(trans_note)" @com-event="refresh_view_edit" />
							</div>

						</div>

					</div>

				</div>
			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr>
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	// Sel_page_and_length 返回表
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_CommonLong,
		Method_CommonLongLong,
		Method_TableAll,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	//查询方式不变的老 模版:返回结果还是字符串:主要变化、编辑区域组件化和增加分页

	//以此为模版同步，所有 主单据+明细项目

	export default {
		components: {
			"pre-btn-Excel": () => import("../per_mode/pre_btn_control.vue"),
			"pre-button": () => import("../per_mode/pre_btn_tan.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue"),
			'per-excelup': () => import("../auto/auto_excel_up.vue")
		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				edit_flag: '', //add 2022-02-15 编辑类型标识
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',
				show_btn: true,

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',
				kw9: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',

				// 明细部分参数
				show_d: false,

				d_btn_more: false,
				d_btn_del: true,
				d_load_url: '',
				d_sel_action: '',
				d_upd_action: '',
				d_row_id: '',
				d_sys_date: '',
				d_parm: [], //明细参数构造
				d_name: [], //明细标题
				d_detail: [], //明细数据

				// 备注
				detail_data: '',
				//文件
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				// 自定义组件 流程
				show_step: '0',
				show_stepdata: '',
				pass_step: "0",
				show_step_btn: false,

				show_note: false,

				max_row: [],
				// 主单据附件判断
				isFileMain: 0,
				show_FileMain: false,
				show_FileChildren: true,

				pre_data: [],

				store_name: '',
				trans_car: {},
				trans_carexp: {},
				sel_carexp_id: '',
				sel_carexp_name: '',
				list_carexp: [],

				sel_carexpbm_id: '',
				sel_carexpbm_name: '',
				list_carexpbm: [],

				trans_carexpname: {},
				trans_note: {}


			};
		},
		watch: {
			pass_step(val) {
				if (val == '1') {
					this.show_step_btn = true;
				} else {
					this.show_step_btn = false;
				}
			},
			isFileMain(val) {
				if (val == '1') {
					this.show_FileMain = true;
					this.show_FileChildren = false;
				} else {
					this.show_FileMain = false;
					this.show_FileChildren = true;
				}
			}

		},
		created: function() {
			console.log('加载====');
			this.load_data();
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d) {
				console.log(d);
				switch (d.key) {
					case 'c_no_1':
						this.trans_car.val = d.val;
						break;
					case 'note':
						this.trans_note.val = d.val;
						break;
				}


			},
			refresh_view_edit_d: function(d) {
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == d.key) {
						this.d_parm[i].val = d.val;
						break;
					}
				}
			},
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			CheckRN(str) {
				let t = '';
				t = str;
				let reg = new RegExp('\r\n', 'g');
				t = t.replace(reg, '<br/>')
				return t;
			},
			show_edit: function() {
				console.log('弹窗。。。。。');
				if (this.show_tan) {
					this.$refs.file_table.showpop();
				} else {
					this.closeshow();
				}


			},
			closeshow: function() {

				this.show_tan = false;
				this.$refs.file_table.hide();

				// 关闭窗口 应该更新编辑信息？=》如果发生编辑 =》才应该进行更新
				// 保证 编辑后清空 全部查询
				// for (let i = 0; i < this.parm_sel.length; i++) {
				//   this.parm_sel[i].val = '';
				// }

				this.load_db_data();

			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: async function() {
				// 初始化最大行数
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.edit_flag = '';
				this.check_key = '';


				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_size = '0';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else {
						this.parm[j].val = '';
					}
				}

				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}

				// 配置参数 start
				this.pre_data = {};
				this.pre_data = JSON.stringify({
					"title": "汽车仓库建立",
					"control": "carstore",
					"step": "0",
					"isFileMain": "0",
					"check_key": "",
					"sel_action": "exp_store_car_storebuild",
					"upd_action": "_store_car_storebuild",
					"detail_part": "0",
					"d_sel_action": "",
					"d_upd_action": "",
					"file_action": "",
					"p1": "",
					"p2": "",
					"p3": "",
					"parm_sel": [{
							"name": "名称",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "c_no_1",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_car",
							"sel_name": "",
							"sel": "3"
						}
					],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "仓库名称"
						},
						{
							"name": "车头牌号"
						},
						{
							"name": "车挂牌号"
						},
						{
							"name": "车挂别名"
						},
						{
							"name": "备注"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [],
					"d_name": []
				});

				this.store_name = '';

				this.trans_car = {
					"name": "车牌",
					"val": "",
					"key": "c_no_1",
					"type": "select",
					"class": "long1",
					"sel_action": "data_base_car",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};
				this.trans_carexp = {
					"name": "车挂",
					"val": "",
					"key": "c_no_2",
					"type": "select",
					"class": "long1",
					"sel_action": "data_base_car_gua",
					"sel_name": "",
					"sel_too": "bieming",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};
				this.trans_carexpname = {
					"name": "别名",
					"val": "",
					"key": "bieming",
					"type": "select",
					"class": "long1",
					"list": [],
					"sel_action": "data_base_car_bm",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};

				this.trans_note = {
					"name": "备注",
					"val": "",
					"key": "note",
					"type": "text",
					"class": "long3",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "4"
				};

				this.sel_carexp_id = '';
				this.sel_carexp_name = '';
				this.list_carexp = [];

				this.sel_carexpbm_id = '';
				this.sel_carexpbm_name = '';
				this.list_carexpbm = [];

				let rescarexp = await this.fun_load_class('data_base_car_gua', '');
				console.log(rescarexp)
				if (rescarexp.data.status == '1') {
					this.list_carexp = rescarexp.data.data;
				} else {
					that.$message({
						type: 'info',
						message: '没有查询到车挂信息'
					});
				}

				// 配置参数 end

				let r = JSON.parse(this.pre_data);
				console.log(r);

				this.title = r.title;
				this.control = r.control;
				this.pass_step = r.step; //判断是否有业务流程
				this.isFileMain = r.isFileMain; //附件保存在主单据 | 还是明细
				// console.log('pass_step=' + this.pass_step);

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				this.edit_flag = r.upd_action.substring(0, 5);
				this.check_key = r.check_key;
				// console.log('编辑标识=' + this.edit_flag);

				this.file_action = r.file_action;
				this.p1 = r.p1;
				this.p2 = r.p2;
				this.p3 = r.p3;

				this.parm_sel = r.parm_sel;
				this.parm = r.parm;
				this.parm_th = r.parm_th;
				// console.log(this.parm_sel);
				// console.log(this.parm);

				// 是否有明细部分
				console.log('明细部分判断=' + r.detail_part == '1');
				if (r.detail_part == '1') {

					this.d_sel_action = r.d_sel_action;
					this.d_upd_action = r.d_upd_action;
					this.d_parm = r.d_parm;
					this.d_name = r.d_name;
					this.d_detail = [];

					this.show_d = true;
					this.fun_d_load();
				}

				this.load_db_data();
			},
			fun_change_carexp: async function() {

				let res = await this.fun_load_class('data_base_car_gua', this.sel_carexp_name);

				if (res.data.status == '1') {
					this.list_carexp = res.data.data;
				} else {
					this.sel_carexp_id = '';
					this.sel_carexp_name = '';
					this.list_carexp = [];
					this.$message({
						type: 'info',
						message: '没有查询到车挂信息'
					});
				}

			},
			fun_change_carexpbm: async function() {


				let res = await this.fun_load_class('data_base_car_bm', this.sel_carexp_name, this.sel_carexpbm_name);

				if (res.data.status == '1') {
					this.list_carexpbm = res.data.data;
				} else {
					this.sel_carexpbm_id = '';
					this.sel_carexpbm_name = '';
					this.list_carexpbm = [];

					this.$message({
						type: 'info',
						message: '没有查询到别名信息'
					});
				}

			},
			choseValue: async function(e, sel) {
				switch (sel) {
					case 'carexp':
						for (let i = 0; i < this.list_carexp.length; i++) {
							if (this.list_carexp[i].id == e) {
								this.sel_carexp_name = this.list_carexp[i].val;
								this.sel_carexp_id = e;
								await this.fun_change_carexpbm();
								break;
							}
						}
						break;
					case 'carexpbm':
						if (typeof(this.sel_carexp_name) === 'undefined' || this.sel_carexp_name == '') {
							this.$message.error('请先选择车挂!');
							return;
						}

						for (let i = 0; i < this.list_carexpbm.length; i++) {
							if (this.list_carexpbm[i].id == e) {
								this.sel_carexpbm_name = this.list_carexpbm[i].val;
								this.sel_carexpbm_id = e;
								break;
							}
						}
						break;

				}

			},
			fun_load_class: function(action, p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2)
					).then(res => {
						res = JSON.parse(res);
						resolve(res)
					});

				});
			},
			select_method: function(type) {
				console.log('操作=' + type);
				switch (type) {
					case 'clear':
						this.data_clear();
						break;
					case 'new':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						this.load_db_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw3 = dateFormatbyChina(this.kw3);
							}
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							if (this.parm_sel[i].type == 'datemonth') {
								this.kw4 = dateFormatbyChina(this.kw4);
							}
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
						case '10':
							this.kw10 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that
						.kw10, r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE' || type == 'PAGE_NOW' || typeof(type) === 'undefined') {
					this.page_length = pagelength;
					this.nowpage = page;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				let back = null;
				if (type == 'UPDATE_OK' && typeof(backdata) != "undefined" && backdata != '') {
					// 更新编辑信息
					this.nowpage = page;
					this.load_db_data();

					back = JSON.parse(backdata);
					console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
							'', '', '',
							'', '', '', '', '', r)
					).then(res => {
						res = JSON.parse(res);

						this.element_loading = false;
						let res_page = [];
						res_page = res[0][0];

						if (res_page.flag == 1) {
							let bd = [];
							// console.log('allcount='+res_page.all_count)
							if (res_page.all_count > 0) {
								let t_list_data = res[1];
								// console.log(t_list_data);
								for (let i = 0; i < t_list_data.length; i++) {
									let arr = [];
									for (let j in t_list_data[i]) {
										let o = {};
										o.key = j;
										let temp_str = '';
										temp_str = t_list_data[i][j];
										if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
											temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
											temp_str = ReplaceAll(temp_str, '\n', "<br/>");
											temp_str = temp_str.replace("\\r\\n", "\r\n");
											temp_str = temp_str.replace("\\n", "\n");
										}
										o.val = temp_str;
										arr.push(o);
									}
									bd.push(arr);
								}
								this.sel_row(bd[0], 'edit');
							}

						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}

					});

					console.log('sheet_flag==' + this.sheet_flag + ' close=' + this.sheet_flag.indexOf('删除成功'))
					if (this.sheet_flag.indexOf('提交成功') >= 0) {
						this.show_btn = false;
					} else {
						this.show_btn = true;
					}

					if (this.sheet_flag.indexOf('删除成功') >= 0) {
						this.closeshow();
						return;
					}

				}

				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			new_blank: function() {
				this.show_tan = true;
				this.show_btn = true;
				this.show_btn_ok = false;
				this.d_detail = [];

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				this.store_name = '';
				this.sel_carexp_name='';
				this.sel_carexpbm_name='';

				this.trans_car = {
					"name": "车牌",
					"val": "",
					"key": "c_no_1",
					"type": "select",
					"class": "long1",
					"sel_action": "data_base_car_ok_two",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};
				this.trans_carexp = {
					"name": "车挂",
					"val": "",
					"key": "c_no_2",
					"type": "select",
					"class": "long1",
					"sel_action": "data_base_car_gua",
					"sel_name": "",
					"sel_too": "bieming",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};
				this.trans_carexpname = {
					"name": "别名",
					"val": "",
					"key": "bieming",
					"type": "select",
					"class": "long1",
					"list": [],
					"sel_action": "data_base_car_bm",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				};

				this.trans_note.val = '';

				for (let j = 0; j < this.parm.length; j++) {
					this.parm[j].val = '';
				}

				this.show_edit();
			},
			edit_data: function() {
				this.show_tan = true;
				// 双击打开界面,如果有明细,应该查询
				// console.log(this.d_upd_action);
				if (typeof(this.d_upd_action) != 'undefined' && this.d_upd_action != '') {
					this.fun_d_load();
				}
				this.show_edit();
			},
			sel_row: async function(item, type) {
				console.log('双击打开', item);
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				let temp_carexp = '',
					temp_carexpname = '';
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							if (this.sheet_flag == '盘点完成') {
								this.show_btn = false;
								this.show_btn_ok = true;
							} else {
								this.show_btn = true;
								this.show_btn_ok = false;
							}
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'name':
							this.store_name = item[i].val;
							break;
						case 'c_no_1':
							this.trans_car.val = '';
							this.trans_car.sel_name = '';
							this.trans_car.val = item[i].val;
							this.trans_car.sel_name = item[i].val;
							break;
						case 'c_no_2':

							this.trans_carexp.val = '';
							this.trans_carexp.sel_name = '';

							this.trans_carexp.sel_name = item[i].val;
							this.sel_carexp_name = item[i].val;

							break;
						case 'bieming':
							this.sel_carexpbm_name = '';
							this.sel_carexpbm_name = item[i].val;

							break;

						case 'note':
							this.trans_note.val = item[i].val;
							break;
						default:
							break;
					}
				}

				if (this.sel_carexp_name != '') {
					await this.fun_change_carexp();
					await this.fun_change_carexpbm();
				}

				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[0].val);
				}



			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				// console.log('===END============')
			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				console.log(this.trans_car);

				// if (this.trans_car.val == '') {
				//   this.$message({
				//     message: this.trans_car.name + '不能为空!',
				//     type: 'warning'
				//   });
				//   return;
				// }

				let d = [];
				d.push(this.store_name);
				d.push(this.trans_car.val);
				d.push(this.sel_carexp_id);
				d.push(this.sel_carexpbm_id);
				d.push(this.trans_note.val)

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d, r);


			},
			fun_edit_base: function(type) {
				// console.log('通用编辑方法 ID=' + this.row_id + ' sys_date=' + this.sys_date);
				let d = '';
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						// add 2022-02-15 必须强制删除所有特殊符号，特别是^
						let temp_val = '',
							temp_key = '',
							temp_type = '';
						temp_key = this.parm[i].key;
						temp_val = this.parm[i].val;
						temp_type = this.parm[i].type;

						if (temp_type == 'time' || temp_type == 'datetime') {
							temp_val = dateFormatbyChina(temp_val)
						}

						if (temp_type == 'textarea') {
							temp_val = temp_val.replace(/\n/g, '<br/>');
							temp_val = temp_val.replace(/\s/g, '&nbsp;');
						}

						d = d + temp_key + '=' + Word_Right_Delete(temp_val) + '^';
					}
				}
				console.log(d);
				d = d.slice(0, -1);

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_TableAll(this.upd_action + type, this.check_key, this.row_id, this.sys_date, d,
					r);
			},
			fun_edit_other: function(type) {
				console.log('自定义编辑方法');
				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {

						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.parm[i].val));
						} else if (this.parm[i].type == 'textarea') {
							// console.log(this.parm[i].val);
							let str = '';
							str = this.parm[i].val;
							// let str = this.parm[i].val;
							str = str.replace(/\n/g, '<br/>');
							str = str.replace(/\s/g, '&nbsp;');
							d.push(str);
						} else {
							// console.log(this.parm[i].val);
							d.push(this.parm[i].val);
						}
					}
				}

				let r = (Math.random() + '').substring(0, 8);
				switch (this.edit_flag) {
					case 'exp15':
						this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
							r);
						break;
					case 'exp30':
						this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date,
							d, r);
						break;
					case 'exp50':
						this.upd_json = Method_CommonLongLong('data_' + this.upd_action + type, this.row_id, this
							.sys_date, d, r);
						break;
				}
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			/****明细部分操作 start***********************************************/
			check_d_parm: function() {
				// console.log('sheet_no=' + this.sheet_no);
				// 当新增时，没有单号，
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no' && this.d_parm[i].val == '') {
						this.d_parm[i].val = this.sheet_no;
						break;
					}
				}

				// 检查必填项目
				let that = this;
				return new Promise((resolve, reject) => {
					let flag = false;
					for (let i = 0; i < that.d_parm.length; i++) {
						if (that.d_parm[i].weight == '1' && that.d_parm[i].val == '') {
							that.$message({
								message: that.title + '明细: ' + that.d_parm[i].name + '为必填项,不能为空!',
								type: 'warning'
							});
							flag = true;
							break;
						}
					}
					resolve(flag)
				})
			},
			d_data_clear: function() {
				this.d_row_id = '';
				this.d_sys_date = ''; //备份点击项目
				// 文件名称、路径、储存 选择确定
				// this.sheet_flag='';
				// this.sheet_no='';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.d_parm.length; j++) {
					if (this.d_parm[j].type != 'select') {
						this.d_parm[j].val = '';
					} else {
						this.d_parm[j].val = '';
						this.d_parm[j].sel_name = '';
						this.d_parm[j].sel_val = {};
					}
				}
			},
			fun_d_upd: function(item, type) {
				// console.log('编辑');
				console.log(item);
				this.d_row_id = item.id;
				this.d_sys_date = item.sys_date;

				for (let j = 0; j < this.d_parm.length; j++) {
					for (let d in item) {
						if (this.d_parm[j].key == d) {
							// console.log(d + '=' + item[d]);
							this.d_parm[j].val = item[d];
							break;
						}
					}
				}

				for (var i = 0; i < this.d_detail.length; i++) {
					if (this.d_detail[i].row_num == item.row_num) {
						document.getElementById('d_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.d_detail[i].row_num % 2 == 0) {
							document.getElementById('d_' + this.d_detail[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('d_' + this.d_detail[i].row_num).style.background = '#f5f5f5';
						}
					}
				}

				if (type == '_del') {
					this.fun_d_save('_del');
				}

			},
			fun_d_load: function() {
				// 当新增时，没有单号，
				for (let i = 0; i < this.d_parm.length; i++) {
					if (this.d_parm[i].key == 'sheet_no' && this.d_parm[i].val == '') {
						this.d_parm[i].val = this.sheet_no;
						break;
					}
				}

				this.d_detail = [];

				if (this.sheet_no == null || this.sheet_no == '') {
					return;
				}

				this.element_loading = true;
				this.$post(
					api.http_method,
					Sel_page_and_length(this.d_sel_action, 1, 999, this.sheet_no)
				).then(res => {
					this.element_loading = false;

					res = JSON.parse(res);
					console.log(res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.d_detail.push(t[i]);
						}
						console.log(this.d_detail);
					} else {
						this.$message({
							message: "没有查询到明细",
							type: 'success'
						});
					}
				});
			},
			fun_d_save: async function(type) {
				if (type == '_del') {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要删除的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let flag = false;
					flag = await this.check_d_parm();
					if (flag) {
						return;
					}
				} else {
					if (this.d_row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.d_parm.length; i++) {

					if (this.d_parm[i].p == '1') {
						if (this.d_parm[i].type == 'time' || this.d_parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.d_parm[i].val));
						} else {

							d.push(this.d_parm[i].val);
						}
					}
				}
				console.log('d_row_id=' + this.d_row_id);
				let temp_data = '';
				temp_data = Method_Common('data_' + this.d_upd_action + type, this.d_row_id, this.d_sys_date, d);

				this.element_loading = true;
				this.$post(
					api.http_method, temp_data
				).then(res => {
					try {
						res = JSON.parse(res);
						console.log(res);
						if (res.data.status == 1) {
							this.$message({
								message: res.data.msg,
								type: 'success'
							});

							this.d_row_id = res.data.parm.id;
							this.d_sys_date = res.data.parm.sys_date;

							//同步 总单据数据
							for (let i = 0; i < this.parm.length; i++) {
								switch (this.parm[i].key) {
									case 'amount':
										this.parm[i].val = res.data.parm.amount;
										break;
									case 'amount_in':
										this.parm[i].val = res.data.parm.amount_in;
										break;
									case 'amount_no':
										this.parm[i].val = res.data.parm.amount_no;
										break;
									case 'amount_dis':
										this.parm[i].val = res.data.parm.amount_dis;
										break;

								}
							}

							// document.getElementById('isfirst').focus();
							let that = this;
							setTimeout(function() {
								that.fun_d_load();
							}, 200)

						} else {
							this.$message.error(res.data.msg);
						}
						this.element_loading = false;

					} catch (ex) {
						this.element_loading = false;
						this.$message({
							message: "查询失败" + ex,
							type: 'warning'
						});
					}
				})

			},
			/****明细部分操作 end***********************************************/
			build_exceldata: function(type) {
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.sel_action, this.nowpage, this.page_length, this.kw1,
							this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10
						)
					});

					this.show_excel = true;
				}
			},
			setActiveRowBackColor: function(key, id, type) {
				console.log('key=' + key + ' id=' + id + ' type=' + type);
				key = key + '_';
				switch (type) {
					case 'detail':
						for (var i = 0; i < this.d_detail.length; i++) {
							// console.log(this.d_detail[i]);
							if (this.d_detail[i][0].val == id) {
								document.getElementById(key + id).style.background = '#92a4f3';
							} else {
								if (this.d_detail[i][0].val % 2 == 0) {
									document.getElementById(key + this.d_detail[i][0].val).style.background = '#fff';
								} else {
									document.getElementById(key + this.d_detail[i][0].val).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
					case 'main':
						break;
				}
			},
			//附件操作 start //////////////////////////////////////
			fun_show_detail: function(t) {
				console.log(t);
				this.file_url = '';
				this.file_src = '';
				this.file_url = decodeURI(t.f_url);
				this.file_src = decodeURI(t.f_src);
				let tt = BackSpecial(this.file_url);
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				this.fun_look_file();
			},
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_data = '';
				this.file_backdata = '';
				if (this.isFileMain == '1') {
					if (this.row_id == null || Number(this.row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
						});
						return;
					}
				} else {
					if (this.d_row_id == null || Number(this.d_row_id) == 0) {
						this.$message({
							dangerouslyUseHTMLString: true,
							message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 明细项目名称</div>请检查!'
						});
						return;
					}
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				let fileobj = document.getElementById('hetong_file');

				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();

			},
			fun_look_file: function() {
				console.log('点击预览附件');
				// console.log(this.parm);
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + this.file_action + '_del","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.row_id +
						'"}';
				} else {
					postdata =
						'{"action":"' + this.file_action + '_del","user_no":"' +
						GetShort("userno") +
						'","sheet_no":"' +
						this.sheet_no +
						'","rowid":"' +
						this.d_row_id +
						'"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// //console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					if (this.isFileMain == '0') {
						that.fun_d_load();
					} else {
						this.load_db_data();
					}

				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + this.file_action + '_add","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						this.file_data +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.row_id + '","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';
				} else {
					postdata =
						'{"action":"' + this.file_action + '_add","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						// '","upfile_size":"' +
						// this.file_size +
						'","upfile_data":"' +
						this.file_data +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.d_row_id +
						'","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';

				}

				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						if (this.isFileMain == '0') {
							that.fun_d_load();
						} else {
							this.load_db_data();
						}

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// //console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// //console.log('上传长度=' + temp_data.size);
					// //console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						//console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// 这里保存文件数据。因为是切片追加模式，而且不写路径。所以row_id和sheet_no 不用传
				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_size":"' +
						this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.row_id + '","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';
				} else {
					postdata =
						'{"action":"' + this.file_action + '_add","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_size":"' +
						this.file_size +
						'","upfile_data":"' +
						temp_filedata +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.d_row_id + '","p1":"' +
						this.p1 +
						'","p2":"' +
						this.p2 +
						'","p3":"' +
						this.p3 +
						'"}';

				}

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// //console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// //console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				//console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";


				if (this.isFileMain == '1') {
					postdata =
						'{"action":"' + this.file_action + '_add","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.row_id + '"}';
				} else {
					postdata =
						'{"action":"' + this.file_action + '_add","user_no":"' +
						GetShort("userno") +
						'","upfile_name":"' +
						DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
						// '","upfile_type":"' +
						// this.file_type +
						'","upfile_path":"' +
						this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
						'","upfile_data":"' +
						'' +
						'","rowid":"' +
						this.d_row_id +
						'","sheet_no":"' +
						this.check_key + '_' + this.d_row_id + '"}';
				}

				// //console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pre_tab {
		width: auto;
		overflow-x: auto;
		white-space: nowrap;
		/* max-width: 1280px; */
	}

	.pre_table_detail_new {
		margin-top: 3px;
		/* table-layout:fixed; 这样做可以使半角连续字符强制换行，不至于撑破列宽。
    需要注意的是，使用此参数后，不要轻易在tr(行)或td(列)
    中加入height属性，会使table不再被内容撑出适合的高度 */
		table-layout: fixed;
		word-break: break-all;
		word-wrap: break-word;
		border-collapse: collapse;
		margin: 0;
		padding: 0;

	}

	.pre_table_detail_new td {
		/* padding: 2px 6px 2px 6px; */
		vertical-align: middle;
		box-sizing: border-box;
		min-width: 1px;
		/* width: auto; */
		/* max-width: 256px; */
		font-size: 14px;
		text-align: center;
		height: 24px;
		line-height: 22px;
		/* border: 1px solid #3f3f3f; */
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		/* 避免长单词截断，保持全部 */

		/* 换行 */
		/* white-space: pre-line;
    word-wrap: break-word;
    word-break: break-all; */
	}

	.tab_header_new td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
	}

	/* 首列是ID,不排序,隐藏 */
	.pre_table_detail_new tr td:nth-child(1) {
		display: none;
	}

	.pre_table_detail_new tr td:nth-child(2) {
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	.pre_table_detail_new tr td:nth-last-child(1) {
		min-width: 168px;
		width: 168px;
	}

	.tab_tr_all>td {
		vertical-align: baseline;
		padding: 2px 5px 2px 5px;
		background-color: rgb(134, 202, 219);
		border: 1px solid #3f3f3f;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
		height: 25px;
		line-height: 25px;
	}

	/* 表格内按钮 */
	.pre_table_detail_new td button {
		border: 1px solid #aaa;
		text-align: center;
		display: inline-block;
		margin-left: 2px;
		margin-right: 2px;
		cursor: pointer;
		border-radius: 5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	/* 表格内输入框 */
	.pre_table_detail_new td input {
		width: 100%;
		height: 100%;
		border: 0px;
		text-align: left;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
	}

	.pre_table_detail_new td span {
		width: 24px;
		height: 24px;
		border: 0px;
		text-align: left;
		background-color: #cfcfcf;
		padding: 2px 2px 2px 2px;
		font-size: 14px;
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
	}

	.pre_table_detail_new td span:hover {
		cursor: pointer;
		background: #aaa;
		/* font-size: 16px; */
	}

	.pre_table_detail_new tr:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.pre_table_detail_new tr:nth-child(even) {
		background-color: #fff;
	}

	.pre_table_detail_new tr:hover {
		background-color: #b8f8b8 !important;
	}

	/* 取消a标签的默认样式 */
	a {
		/* display: block; */
		height: 100%;
		text-decoration: none;
		color: #333;
	}

	.pre_table_detail_new tr>td>a:focus {
		background: #92a4f3 !important;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	/*  .last-two-none>td:nth-last-child(3),
  .last-two-none>td:nth-last-child(2) {
    display: none;
  }

  .last-two-none>td:nth-last-child(2) {
    display: none;
  }
 */

	.pre_leve_one {
		margin: 0px;
	}

	.content_edit_item label {
		display: inline-block;
		min-width: 96px;
	}


	.tab-row {
		display: block;
		overflow: auto;
	}


	.pop_content_body {
		z-index: 999;
		position: fixed;
		height: 50vh;
		max-height: 80%;
		
		width: 520px;
		/* border: 1px solid black; */
		border-radius: 5px 5px 5px 5px;
		background-color: rgb(195, 219, 250);
		overflow: hidden;
		padding: 6px;
		/* 下面按需调整 */
		text-align: left;
		top: 10vh;
		left: calc((100% - 520px)/2);
		
	}

	.pre_tan_head_close {
		display: flex;
		justify-content: flex-end;
		margin-bottom: -16px;
	}

	.pre_tan_head_close img:hover {
		cursor: pointer;
	}
</style>
